<script setup>
import { computed } from 'vue';
import BarChart from 'shared/components/charts/BarChart.vue';
import { CHART_FONT_FAMILY } from '../../constants';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  rows: {
    type: Array,
    default: () => [],
  },
  valueKey: {
    type: String,
    default: 'total',
  },
  fallbackName: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    default: 'rgb(31, 147, 255)',
  },
  emptyMessage: {
    type: String,
    required: true,
  },
});

const collection = computed(() => ({
  labels: props.rows.map(row => row.name || props.fallbackName),
  datasets: [
    {
      type: 'bar',
      backgroundColor: props.color,
      label: props.title,
      data: props.rows.map(row => row[props.valueKey] || 0),
    },
  ],
}));

const chartOptions = {
  plugins: {
    legend: { display: false },
  },
  scales: {
    x: {
      ticks: { fontFamily: CHART_FONT_FAMILY },
      grid: { drawOnChartArea: false },
    },
    y: {
      type: 'linear',
      position: 'left',
      ticks: { fontFamily: CHART_FONT_FAMILY, beginAtZero: true, stepSize: 1 },
      grid: { drawOnChartArea: false },
    },
  },
};
</script>

<template>
  <div
    class="flex flex-col gap-2 p-4 rounded-xl outline outline-1 outline-n-container bg-n-solid-2"
  >
    <span class="text-heading-3 text-n-slate-12">{{ title }}</span>
    <div class="h-56">
      <BarChart
        v-if="rows.length"
        :collection="collection"
        :chart-options="chartOptions"
      />
      <div
        v-else
        class="flex items-center justify-center h-full text-sm text-n-slate-10"
      >
        {{ emptyMessage }}
      </div>
    </div>
  </div>
</template>
